import React from 'react';
import PvsCreativeContainer from 'containers/PvsCreativeContainer';
import { platform } from 'os';

interface PvsCreativeViewProps {
  name: string;
  platformId: number;
  pvsCreativeId: string;
  onViewFinished(): void;
}

const PvsCreativeView: React.FunctionComponent<PvsCreativeViewProps> = ({
  name,
  platformId,
  pvsCreativeId,
  onViewFinished
}) => {
  const width = platformId === 1 ? 300 : 320;
  const height = platformId === 1 ? 600 : 50;

  let platformName = 'Unknown';

  if (platformId === 1) {
    platformName = 'Web';
  } else if (platformId === 2) {
    platformName = 'Mobile';
  }

  return (
    <PvsCreativeContainer pvs_creative_id={pvsCreativeId} getContent={true}>
      {({ creativeContent }) => (
        <section className="view-creative__container">
          <div>
            <h5>{name}</h5>
            <div className="saturn-form-group">
              <label>Platform:</label>
              <span className="view-creative__platform">{platformName}</span>
            </div>
          </div>
          {creativeContent ? (
            <img
              height={height}
              width={width}
              src={`data:image/jpeg;charset=utf-8;base64, ${creativeContent.bytes}`}
            />
          ) : (
            <p className="view-creative__empty">No content available</p>
          )}
          <div>
            <button className="btn btn-link view-creative__cancel" onClick={onViewFinished}>
              Close
            </button>
          </div>
        </section>
      )}
    </PvsCreativeContainer>
  );
};

export default PvsCreativeView;
